import { render, staticRenderFns } from "./placeOn.vue?vue&type=template&id=220df1ab&scoped=true"
import script from "./placeOn.vue?vue&type=script&lang=js"
export * from "./placeOn.vue?vue&type=script&lang=js"
import style0 from "./placeOn.vue?vue&type=style&index=0&id=220df1ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220df1ab",
  null
  
)

export default component.exports